import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';

import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient, HttpHeaders, HttpResponse, HttpHandler } from '@angular/common/http';
import { AppRoutingModule } from './app.routing.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxTwitterTimelineModule } from 'ngx-twitter-timeline';

import { MyDatePickerModule } from 'mydatepicker';

import { AuthService } from './auth/auth.service';
import { AuthGuard } from './auth/auth.guard';

import { ModalService } from './shared/modal/modal.service';
import { SnackBarService } from './shared/snackbar/snackbar.service';
import { AdvisorBarService } from './shared/advisor-bar/advisor-bar.service';
import { UserService } from './services/user.service';
import { SidebarService } from './services/sidebar.service';
import { GlobalService } from './services/global.service';
import { OrganizationService } from './services/organization.service';
import { PagerService } from './services/pager.service';
import { MenuService } from './services/menu.service';
import { LoadingService } from './shared/loading/loading.service';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { TopnavComponent } from './shared/topnav/topnav.component';
import { ModalComponent } from './shared/modal/modal.component';
import { SnackBarComponent } from './shared/snackbar/snackbar.component';
import { TimeoutComponent } from './shared/timeout/timeout.component';
import { InfoIconComponent } from './shared/info-icon/info-icon.component';
import { LoadingComponent } from './shared/loading/loading.component';
import { AdvisorBarComponent } from './shared/advisor-bar/advisor-bar.component';
import { BreadCrumbComponent } from './shared/breadcrumbs/breadcrumbs.component';

import { AdminComponent } from './admin/admin.component';
import { MetricRectangleComponent } from './shared/metric-rectangle/metric-rectangle.component';
import { AdvisorsComponent } from './advisors/advisors.component';
import { ClientsComponent } from './clients/clients.component';
import { ViewOrganizationsComponent } from './view-organizations/view-organizations.component';
import { SettingsComponent } from './settings/settings.component';
import { AuthWrapperComponent } from './auth-wrapper/auth-wrapper.component';
import { PortfolioRecommendationComponent } from './portfolio-recommendation/portfolio-recommendation.component';
import { ApplicationsComponent } from './applications/applications.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { InfoCenterComponent } from './info-center/info-center.component';
import { SupportComponent } from './support/support.component';
import { ReportsComponent } from './reports/reports.component';
import { LegacyReportsComponent } from './legacy-reports/legacy-reports.component';
import { CreateReportComponent } from './create-report/create-report.component';
import { ViewReportsComponent } from './view-reports/view-reports.component';
import { SocialSecurityComponent } from './social-security/social-security.component';
import { MedicareMeansTestingComponent } from './medicare-means-testing/medicare-means-testing.component';
import { MedicareMeansTestingComponentV2 } from './medicare-means-testing-v2/medicare-means-testing-v2.component';
import { HealthCareComponent } from './healthcare/healthcare.component';
import { LongTermCareComponent } from './long-term-care/long-term-care.component';
import { LeadsComponent } from './leads/leads.component';
//import { MetricsComponent } from './metrics/metrics.component';
import { MetricsComponentV2 } from './metrics-v2/metrics-v2.component';
import { CreateReportSelectionComponent } from './create-report-selection/create-report-selection.component';
import { MarketingMaterialComponent } from './marketing-material/marketing-material.component';

import { ForgotPasswordComponent } from './forgot-password/forgotpassword.component';
import { ResetPasswordComponent } from './reset-password/resetpassword.component';
import { RegisterComponent } from './register/register.component';
import { SignUpComponent } from './sign-up/sign-up.component';
//import { ComboChartComponent, ComboSeriesVerticalComponent } from './combo-chart';

//recaptcha
import {RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings} from 'ng-recaptcha';
import {RecaptchaFormsModule} from 'ng-recaptcha/forms';

import { DragAndDropModule } from 'angular-draggable-droppable';

//material
import { MatButtonModule, MatButtonToggleModule, MatTooltipModule } from '@angular/material';

import { Ng5SliderModule } from 'ng5-slider';
import { DecimalPipe } from '@angular/common';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CommonModule, CurrencyPipe} from '@angular/common';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    HomeComponent,
    SidebarComponent,
    TopnavComponent,
    ModalComponent,
    SnackBarComponent,
    TimeoutComponent,
    MetricRectangleComponent,
    AdvisorsComponent,
    ClientsComponent,
    SettingsComponent,
    AuthWrapperComponent,
    PortfolioRecommendationComponent,
    ApplicationsComponent,
    OrganizationsComponent,
    InfoCenterComponent,
    SupportComponent,
    ReportsComponent,
    LegacyReportsComponent,
    CreateReportComponent,
    ViewReportsComponent,
    SocialSecurityComponent,
    MedicareMeansTestingComponent,
    MedicareMeansTestingComponentV2,
    HealthCareComponent,
    LongTermCareComponent,
    CreateReportSelectionComponent,
    MarketingMaterialComponent,
    ViewOrganizationsComponent,
    InfoIconComponent,
    LoadingComponent,
    AdvisorBarComponent,
    BreadCrumbComponent,
    LeadsComponent,
    MetricsComponentV2,
    AdminComponent,
   /*  ComboChartComponent,
    ComboSeriesVerticalComponent */
  ],
  imports: [
    BrowserModule,
    HttpModule,
    NgxTwitterTimelineModule,
    HttpClientModule,
    AppRoutingModule,
    NgxChartsModule,
    BrowserAnimationsModule,
    MatButtonModule, MatButtonToggleModule, MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    MyDatePickerModule,
    DragAndDropModule,
    Ng5SliderModule,
    CurrencyMaskModule,
    CommonModule,
  ],
  providers: [
    AuthService,
    AuthGuard,
    ModalService,
    SnackBarService,
    AdvisorBarService,
    UserService,
    SidebarService,
    GlobalService,
    OrganizationService,
    PagerService,
    MenuService,
    LoadingService,
    HttpClient,
    //GlobalService,
    DecimalPipe,
    CurrencyPipe,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { 
        siteKey: '6LeOczsUAAAAAOaCRf0YOQ8l7oIemk08k8ccmYBe', //same key used for hvsfinancial.com, bamria.com and healthycapital.com
        //secret key: 6LeOczsUAAAAAGQFLjoZAYWF4KadtsDOE-NXM3fW
      } as RecaptchaSettings,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
